import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import HttpClient from "../network/http";
import { fetchCsrfToken } from "../context/AuthContext";
import SchoolProfileService from "../service/schoolProfile";

const baseURL = process.env.REACT_APP_BASE_URL;

export default function useSchoolProfile({ schoolid } = {}) {
  const queryClient = useQueryClient();
  const httpClient = new HttpClient(baseURL, () => fetchCsrfToken());
  const service = new SchoolProfileService(httpClient);

  const profileQuery = useQuery(
    ["schoolProfileAdmin", schoolid],
    () => service.getAdminProfile(schoolid),
    {
      enabled: !!schoolid,
      staleTime: 1000 * 60,
    },
  );

  const upsertProfileMutation = useMutation(
    (payload) => service.upsertAdminProfile(payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["schoolProfileAdmin", schoolid]);
      },
    },
  );

  const publicProfileQuery = useQuery(
    ["schoolProfilePublic", schoolid],
    () => service.getPublicProfileBySchoolId(schoolid),
    {
      enabled: !!schoolid,
      staleTime: 1000 * 60,
    },
  );

  return {
    profileQuery,
    upsertProfileMutation,
    publicProfileQuery,
  };
}
